import secureApi from "../services/secureApi";

export const getAllColors = async ({ search = "", sort = "desc" } = {}) => {
  try {
    const params = { sort };

    if (search?.trim()) {
      params.search = search.trim();
    }

    const response = await secureApi.get("/admin/color/list", {
      params,
    });

    return response.data;
  } catch (error) {
    console.error("GET color LIST ERROR", error);
    throw error;
  }
};


export const getColorById = async (id) => {
  try {
    const response = await secureApi.get(`/admin/color/view/${id}`);
    return response.data;
  } catch (error) {
    console.error("GET COLOR ERROR:", error);
    return null;
  }
};

export const addColor = async (data) => {
  try {
    const response = await secureApi.post("/admin/color/add", data);
    return response.data;
  } catch (error) {
    console.error("ADD COLOR ERROR:", error);
    throw error;
  }
};

export const editColor = async (id, data) => {
  try {
    const response = await secureApi.put(`/admin/color/edit/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("EDIT COLOR ERROR:", error);
    throw error;
  }
};

export const deleteColor = async (id) => {
  try {
    const response = await secureApi.delete(`/admin/color/delete/${id}`);
    return response.data;
  } catch (error) {
    console.error("DELETE COLOR ERROR:", error);
    throw error;
  }
};